import {
  get, post, put, remove,
} from '../../services/api.service';

const state = {
  usersList: [],
  headersList: [
    {
      text: 'Imię i nazwisko',
      value: 'name',
    },
    {
      text: 'Adres e-mail',
      value: 'email',
    },
    {
      text: 'Typ',
      value: 'type',
    },
    {
      text: 'Data dodania',
      value: 'created_at',
    },
    {
      text: 'Akcje',
      sortable: false,
      align: 'center',
      value: 'action',
    },
  ],
};

const mutations = {
  setUsersList(data, payload) {
    data.usersList = payload;
  },
};

const getters = {
  getUsersList: data => data.usersList,
  getHeaders: data => data.headersList,
};

const actions = {
  async fetchUsers(context) {
    try {
      const response = await get('/user');
      context.commit('setUsersList', response);
      return response;
    } catch (e) {
      return e;
    }
  },
  createUser(context, payload) {
    return new Promise((resolve, reject) => {
      post('/user', payload)
        .then((response) => {
          resolve(response.password);
        }, () => {
          reject();
        });
    });
  },
  updateUser(context, payload) {
    return new Promise((resolve, reject) => {
      put(`/user/${payload.id}`, payload)
        .then(() => {
          resolve();
        }, () => {
          reject();
        });
    });
  },
  getPassword(context, payload) {
    return new Promise((resolve) => {
      put(`/user/generate_password/${payload}`)
        .then((response) => {
          resolve(response.password);
        });
    });
  },
  removeUser(context, payload) {
    return new Promise((resolve) => {
      remove(`/user/${payload}`)
        .then(() => {
          context.dispatch('fetchUsers');
          resolve();
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
